/**
 * Created by lihanying on 2018/1/15.
 */
import React from 'react'
import { Modal, Table, Button } from 'antd'
import { clickDownload } from '../../../util/index'
export default class extends React.Component {
  render() {
    const { visible, record, marketRecord } = this.props
    const columns = [
      {
        title: 'id',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: '购买账号',
        dataIndex: 'account',
        key: 'account',
      },
      {
        title: '用户名称',
        dataIndex: 'nickname',
        key: 'nickname',
      },
      {
        title: '商品名称',
        dataIndex: 'c_name',
        key: 'c_name',
      },
      {
        title: '商品分类',
        dataIndex: 'c_type',
        key: 'c_type',
      },
      {
        title: '球台',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '购买时间',
        dataIndex: 'ctime',
        key: 'ctime',
      },
      {
        title: '数量',
        dataIndex: 'qty_sale',
        key: 'qty_sale',
      },
      {
        title: '单价',
        dataIndex: 'price_sale',
        key: 'price_sale',
        render: (text, record) => <span>{record.price_sale / 100}</span>,
      },
      {
        title: '销售总额',
        dataIndex: 'amount_sale',
        key: 'amount_sale',
        render: (text, record) => <span>{record.amount_sale / 100}</span>,
      },
      {
        title: '支付方式',
        dataIndex: 'payment',
        key: 'payment',
      },
      {
        title: '销售班次',
        dataIndex: 'employee',
        key: 'employee',
      },
    ]
    const data =
      (marketRecord.list &&
        marketRecord.list.map((item) => {
          item.c_name = record.commodity_name
          item.c_type = record.type_name
          return item
        })) ||
      []
    return (
      <div>
        <Modal
          title={record.commodity_name}
          visible={visible}
          onCancel={this.props.handleCancel}
          width="1200px"
          footer={null}
        >
          <Button style={{ backgroundColor: '#1AAD19' }}>
            <a
              id="test"
              href={clickDownload(columns, data)}
              download="downlaod.csv"
              style={{ color: 'white' }}
            >
              导出
            </a>
          </Button>
          <Table
            rowKey="id"
            bordered
            columns={columns}
            dataSource={data}
            size="middle"
          />
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubMarket/component/modalRecord.js